export default __webpack_public_path__ + "static/media/hidden-pass.faef7a02.svg";